<template>
  <div class="doctor-consult-statistics">
    <div class="page_title flex between">
      <span>医生行为统计</span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <!-- 搜索条件 -->
        <div class="doctor-consult-statistics-search">
          <el-form
            ref="doctorConsultStatisticsFormRef"
            :inline="true"
            :model="doctorConsultStatisticsForm"
            class="demo-form-inline"
          >
            <el-form-item label="医生认证时间">
              <el-date-picker
                v-model="doctorConsultStatisticsForm.create_time"
                clearable
                type="daterange"
                unlink-panels
                range-separator="——"
                end-placeholder="结束日期"
                start-placeholder="开始日期"
                size="small"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="医生姓名">
              <el-input
                v-model="doctorConsultStatisticsForm.doctor_name"
                clearable
                style="width: 160px"
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item label="医生手机号">
              <el-input
                v-model="doctorConsultStatisticsForm.doctor_phone"
                clearable
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item label="是否测试医生">
              <el-radio-group
                v-model="doctorConsultStatisticsForm.is_test"
                size="small"
                @change="getList"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <template v-if="show_filter_list.length">
              <el-form-item
                v-for="(item, index) in show_filter_list"
                :key="index"
                :label="item.value"
              >
                <!-- 日期 -->
                <el-date-picker
                  v-if="item.type == 'date'"
                  v-model="doctorConsultStatisticsForm[item.key]"
                  :clearable="true"
                  type="daterange"
                  unlink-panels
                  range-separator="——"
                  end-placeholder="结束日期"
                  start-placeholder="开始日期"
                  size="small"
                  @change="
                    forceUpdateBtn(doctorConsultStatisticsForm[item.key])
                  "
                  @blur="forceUpdateBtn(doctorConsultStatisticsForm[item.key])"
                >
                </el-date-picker>

                <!-- 文本输入 -->
                <el-input
                  v-if="item.type == 'input'"
                  v-model="doctorConsultStatisticsForm[item.key]"
                  clearable
                  style="width: 160px"
                  size="small"
                  @input="forceUpdateBtn(doctorConsultStatisticsForm[item.key])"
                ></el-input>

                <!-- 下拉选择 -->
                <el-select
                  v-if="item.type == 'select'"
                  v-model="doctorConsultStatisticsForm[item.key]"
                  clearable
                  placeholder="请选择"
                  size="small"
                  @change="
                    forceUpdateBtn(doctorConsultStatisticsForm[item.key])
                  "
                >
                  <el-option
                    v-for="(listItem, index) in item.list"
                    :key="index"
                    :label="listItem.value"
                    :value="listItem.key"
                  >
                  </el-option>
                </el-select>

                <!-- 范围 -->
                <div v-if="item.type == 'range'">
                  <el-input-number
                    v-model="doctorConsultStatisticsForm[`${item.key}_start`]"
                    size="small"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    style="width: 90px"
                  ></el-input-number>
                  &nbsp;~&nbsp;
                  <el-input-number
                    v-model="doctorConsultStatisticsForm[`${item.key}_end`]"
                    size="small"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    style="width: 90px"
                  ></el-input-number>
                </div>
              </el-form-item>
            </template>

            <el-form-item>
              <el-button type="primary" size="small" @click="searchBtn">
                查 询<i class="el-icon-search el-icon--right" />
              </el-button>

              <!-- 导出 -->
              <el-button
                type="primary"
                size="small"
                @click="derive"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1819') : false
                "
              >
                导出<i class="el-icon-download el-icon--right" />
              </el-button>

              <!-- 将结果添加到医生标签 -->
              <el-button
                type="primary"
                size="small"
                @click="addDoctorLabel"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1837') : false
                "
              >
                将结果添加到医生标签
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 更多筛选 -->
        <div class="flex" style="margin-bottom: 10px">
          <el-button type="primary" size="small" @click="searchMoreBtn">
            更多筛选
          </el-button>

          <!-- 导出 -->
          <el-button type="primary" size="small" @click="fieldMoreBtn">
            列表显示
          </el-button>
        </div>
        <!-- 表格 -->
        <div class="doctor-consult-statistics-table">
          <el-table
            v-loading="tableLoading"
            :header-cell-style="{ background: '#F5F5F5' }"
            :data="doctorConsultStatisticsData"
            @sort-change="changeSort"
            style="width: 100%"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :fixed="item.fixed"
              :sortable="item.sortable"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'doctor_info'">
                  <div>
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </div>

                <div v-else-if="item.prop == 'reg_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'last_consult_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'last_prescription_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'avg_agree_time'">
                  <span v-if="scope.row[item.prop]">
                    {{ scope.row[item.prop] }} 分钟</span
                  >
                </div>

                <div v-else-if="item.prop == 'avg_first_msg_time'">
                  <span v-if="scope.row[item.prop]">
                    {{ scope.row[item.prop] }} 分钟</span
                  >
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="200"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1820')
                      : false
                  "
                  @click="toDetail(scope.row)"
                  >接诊详情</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1843')
                      : false
                  "
                  @click="toPrescriptionDetail(scope.row)"
                  >处方详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 更多筛选项 -->
    <el-dialog
      title="更多筛选"
      :visible.sync="filterDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      custom-class="filter-dialog-visible"
    >
      <div class="checkbox-box">
        <el-checkbox-group v-model="show_filter_key" size="medium">
          <el-checkbox
            border
            v-for="(item, index) in filter_list"
            :key="index"
            :label="item.key"
            @change="showFilterChange(item)"
            >{{ item.value }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="filterDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmFilterDialog">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 更多列表项 -->
    <el-dialog
      title="列表显示"
      :visible.sync="fieldDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      custom-class="filter-dialog-visible"
    >
      <div class="checkbox-box">
        <el-checkbox-group v-model="show_field_key" size="medium">
          <el-checkbox
            border
            v-for="(item, index) in field_list"
            :key="index"
            :label="item.key"
            >{{ item.value }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fieldDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmFieldDialog">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 将结果添加到医生标签 -->
    <el-dialog
      title="添加标签"
      :visible.sync="labelDialog"
      width="600px"
      style="text-align: left"
      :close-on-click-modal="false"
      append-to-body
      class="cus-label"
    >
      <div class="add-box">
        <el-form
          :model="labelForm"
          :rules="rules"
          ref="labelFormRef"
          label-width="140px"
          class="info-form"
        >
          <el-form-item label="标签名" prop="label_name">
            <el-input
              v-model="labelForm.label_name"
              style="width: 400px"
              maxlength="10"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="标签类别" prop="label_type">
            <el-select v-model="labelForm.label_type" placeholder="请选择">
              <el-option label="医生唯一标签" :value="1"> </el-option>
              <el-option label="医生外显标签" :value="2"> </el-option>
              <el-option label="医生客服标签" :value="3"> </el-option>
              <el-option label="医生标记标签" :value="4"> </el-option>
              <el-option label="医生运营标签" :value="5"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="图标" prop="image" class="image-box">
            <el-upload
              list-type="picture-card"
              :action="uploadUrl"
              :show-file-list="false"
              name="image"
              accept=".png,.jpeg,.jpg"
              ref="iconImgRef"
              class="box"
              :headers="uploadHeaders"
              :data="uploadExtraData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeUpload"
            >
              <img
                v-if="labelForm.label_img_str"
                :src="labelForm.label_img_str"
                style="width: 148px; height: 148px"
              />
              <div v-else class="icon-box">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div
                v-show="labelForm.label_img_str"
                class="shadow column-center column"
              >
                <div>
                  <i class="el-icon-delete" @click.stop="delImg()"></i>
                </div>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item class="btn-box">
            <el-button @click="labelDialog = false">取 消</el-button>
            <el-button type="primary" @click="confirmLabel('labelFormRef')"
              >保 存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import marketing from "@/api/marketing";
import constant from "@/service/common/constant";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      moduleName: 1,
      orderForm: {
        // 排序
        orderby: 0,
      },
      doctorConsultStatisticsForm: {
        doctor_name: "",
        doctor_phone: "",
        create_time: [],
        is_test: 2,
      },
      total: 100,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "医生信息",
          prop: "doctor_info",
          width: "120",
          fixed: "left",
        },
        {
          label: "医生注册时间",
          prop: "reg_time",
          width: "auto",
          fixed: false,
        },
        {
          label: "医生认证时间",
          prop: "create_time",
          width: "auto",
          fixed: false,
        },
        {
          label: "推荐人",
          prop: "recommender_name",
          width: "auto",
          fixed: false,
        },
        {
          label: "推荐人手机号",
          prop: "recommender_phone",
          width: "auto",
          fixed: false,
        },

        {
          label: "最后接诊时间",
          prop: "last_consult_time",
          width: "auto",
          fixed: false,
        },
        {
          label: "最后开方时间",
          prop: "last_prescription_time",
          width: "auto",
          fixed: false,
        },
      ],
      doctorConsultStatisticsData: [],
      fieldDialogVisible: false,
      field_list: [], // 列表显示
      show_field_key: [],
      show_field_list: [],
      filterDialogVisible: false,
      filter_list: [], // 更多筛选
      show_filter_key: [],
      show_filter_list: [],
      labelDialog: false,
      labelForm: {
        label_name: "",
        label_type: 5,
        label_img: "",
        label_img_str: "",
      },
      rules: {
        label_name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      uploadExtraData: {
        img_type: 4,
        suffix: ".jpg",
      },
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "/api/platform/upload/uploadFile";
      } else {
        return "/platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform", "appid"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.doctorConsultStatisticsForm.create_time = [start, end];
    this.getList();
    this.getDoctorConsultFieldList();
  },
  methods: {
    forceUpdateBtn() {
      this.$forceUpdate();
    },
    getList() {
      this.tableLoading = true;
      let filter_field = this.show_filter_list
        .map((item) => item.key)
        .join(",");
      let list_field = this.show_field_list.map((item) => item.key).join(",");
      let params = Object.assign(
        { filter_field, list_field },
        this.orderForm,
        this.pagination,
        this.doctorConsultStatisticsForm
      );
      for (let key in params) {
        if (Array.isArray(params[key])) {
          params[key] = `${dayjs(params[key][0]).format("YYYY-MM-DD")},${dayjs(
            params[key][1]
          ).format("YYYY-MM-DD")}`;
        }
      }

      marketing.getDoctorConsultList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          this.doctorConsultStatisticsData = data.list;
          this.tableLoading = false;
        }
      });
    },
    // 排序
    //更改顺序
    changeSort(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == "ascending") {
        if (prop == "avg_agree_time") {
          this.orderForm.orderby = 1;
        }
      }
      //降序
      if (order == "descending") {
        if (prop == "avg_agree_time") {
          this.orderForm.orderby = 2;
        }
      }
      if (!order) {
        this.orderForm.orderby = 0;
      }
      this.getList();
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    // 导出
    derive() {
      let filter_field = this.show_filter_list
        .map((item) => item.key)
        .join(",");
      let list_field = this.show_field_list.map((item) => item.key).join(",");
      const loading = this.$loading();
      let params = Object.assign(
        { filter_field, list_field },
        this.pagination,
        this.doctorConsultStatisticsForm
      );
      for (let key in params) {
        if (Array.isArray(params[key])) {
          params[key] = `${dayjs(params[key][0]).format("YYYY-MM-DD")},${dayjs(
            params[key][1]
          ).format("YYYY-MM-DD")}`;
        }
      }

      marketing
        .explodeDoctorConsultList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },

    // 查看详情
    toDetail(row) {
      let { doctor_id, doctor_name } = row;
      let { create_time } = this.doctorConsultStatisticsForm;
      this.$router.push({
        path: "/home/marketing/doctorConsultDetails",
        query: {
          doctor_id,
          doctor_name,
          create_time: JSON.stringify(create_time),
        },
      });
    },
    // 处方详情
    toPrescriptionDetail(row) {
      let { doctor_id, doctor_name } = row;
      let { create_time } = this.doctorConsultStatisticsForm;
      this.$router.push({
        path: "/home/marketing/doctorPrescriptionDetails",
        query: {
          doctor_id,
          doctor_name,
          create_time: JSON.stringify(create_time),
        },
      });
    },
    // 获取更多筛选项和列表显示字段
    getDoctorConsultFieldList() {
      marketing.getDoctorConsultFieldList().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          console.log(data);
          this.field_list = data.field_list;
          this.filter_list = data.filter_list;
        }
      });
    },
    // 更多筛选---start
    searchMoreBtn() {
      this.filterDialogVisible = true;
    },
    comfirmFilterDialog() {
      this.show_filter_list = this.filter_list.filter((item) => {
        return this.show_filter_key.includes(item.key);
      });

      this.filterDialogVisible = false;
    },
    showFilterChange(item) {
      if (item.type == "range") {
        this.doctorConsultStatisticsForm[`${item.key}_start`] = undefined;
        this.doctorConsultStatisticsForm[`${item.key}_end`] = undefined;
      } else {
        this.doctorConsultStatisticsForm[item.key] = "";
      }
    },
    // 更多筛选---end
    // 更多列表字段---start
    fieldMoreBtn() {
      this.fieldDialogVisible = true;
    },
    comfirmFieldDialog() {
      this.tableHeader = [
        {
          label: "医生信息",
          prop: "doctor_info",
          width: "120",
          fixed: "left",
        },
        {
          label: "医生注册时间",
          prop: "reg_time",
          width: "auto",
          fixed: false,
        },
        {
          label: "医生认证时间",
          prop: "create_time",
          width: "auto",
          fixed: false,
        },
        {
          label: "推荐人",
          prop: "recommender_name",
          width: "auto",
          fixed: false,
        },
        {
          label: "推荐人手机号",
          prop: "recommender_phone",
          width: "auto",
          fixed: false,
        },

        {
          label: "最后接诊时间",
          prop: "last_consult_time",
          width: "auto",
          fixed: false,
        },
        {
          label: "最后开方时间",
          prop: "last_prescription_time",
          width: "auto",
          fixed: false,
        },
      ];
      this.show_field_list = this.field_list.filter((item) => {
        return this.show_field_key.includes(item.key);
      });

      let arr = this.show_field_list.map((item) => {
        let obj = {
          label: item.value,
          prop: item.key,
          width: "auto",
          fixed: false,
          sortable: item.key == "avg_agree_time" ? "custom" : false,
        };
        return obj;
      });
      this.tableHeader = this.tableHeader.concat(arr);

      this.fieldDialogVisible = false;
    },
    // 更多列表字段---end
    // 将结果添加到医生标签
    addDoctorLabel() {
      this.labelForm = {
        label_name: "",
        label_type: 5,
        label_img: "",
        label_img_str: "",
      };
      this.labelDialog = true;
    },
    confirmLabel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let filter_field = this.show_filter_list
            .map((item) => item.key)
            .join(",");
          let list_field = this.show_field_list
            .map((item) => item.key)
            .join(",");

          let params = Object.assign(
            { filter_field, list_field },
            this.labelForm,
            this.doctorConsultStatisticsForm
          );

          for (let key in params) {
            if (Array.isArray(params[key])) {
              params[key] = `${dayjs(params[key][0]).format(
                "YYYY-MM-DD"
              )},${dayjs(params[key][1]).format("YYYY-MM-DD")}`;
            }
          }

          marketing.addDoctorConsultLabel(params).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success("添加成功");
              this.labelDialog = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList) {
      let { code, data } = res;
      if (code === 0) {
        this.labelForm.label_img_str = data.path;
        this.labelForm.label_img = data.pic;
        this.$message.success("上传图片成功");
      }
    },
    // 上传之前
    beforeUpload(file) {
      const supportImgTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error("上传图片只能是 jpg, png, jpeg 格式!");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
    },
    delImg() {
      this.labelForm.label_img_str = "";
      this.labelForm.label_img = "";
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 10px 20px;
}
.doctor-consult-statistics {
  .doctor-consult-statistics-search {
    .el-form {
      display: flex;
      flex-wrap: wrap;
      // align-items: center;
      .el-form-item {
        margin-bottom: 10px;
      }
    }
  }
  .doctor-consult-statistics-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
  <style lang="scss">
.filter-dialog-visible {
  .checkbox-box {
    padding: 10px;
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      .el-checkbox {
        margin: 10px;
      }
    }
  }
}
.cus-label {
  .add-box {
    padding: 20px 10px 1px;
    display: flex;
    .icon-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 148px;
      height: 148px;
    }
    .box {
      position: relative;
      width: 148px;
      &:hover .shadow {
        display: flex;
      }
      img {
        width: 148px;
        height: 148px;
      }
      .shadow {
        position: absolute;
        left: 0;
        top: 0;
        width: 148px;
        height: 148px;
        background-color: rgba(0, 0, 0, 0.6);
        display: none;
      }
      .el-icon-delete {
        font-size: 30px;
        text-align: center;
        cursor: pointer;
        color: #d44747;
      }
    }
    .btn-box {
      text-align: right;
      padding-right: 20px;
    }
  }
  .image-box {
    .el-form-item__content {
      height: auto !important;
    }
  }
}
</style>